import { Route, Routes } from "react-router-dom";

import { useIsAdmin } from "./hooks/useIsAdmin";
import { AccountPage } from "./pages/AccountPage";
import { AdminPage } from "./pages/AdminPage";
import { BetaUsersPage } from "./pages/BetaUsersPage";
import { CoffeeCheckInPage } from "./pages/CoffeeCheckInPage";
import { CoffeeDetailPage } from "./pages/CoffeeDetailPage";
import { CrawlRunsPage } from "./pages/CrawlRunsPage";
import { GreenCoffeeReviewPage } from "./pages/GreenCoffeeReviewPage";
import { HomePage } from "./pages/HomePage";
import { ListingsReviewPage } from "./pages/ListingsReviewPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { RequestPage } from "./pages/RequestPage";
import { RequestsPage } from "./pages/RequestsPage";
import { RoastersPage } from "./pages/RoastersPage";
import { SearchResultsPage } from "./pages/SearchResultsPage";

// Cosmetic gate only: non-admins get the same 404 as any unknown path,
// so /admin doesn't advertise itself. The API's admin middleware is the
// real enforcement.
function AdminRoute() {
  return useIsAdmin() ? <AdminPage /> : <NotFoundPage />;
}

function BetaUsersRoute() {
  return useIsAdmin() ? <BetaUsersPage /> : <NotFoundPage />;
}

function RoastersRoute() {
  return useIsAdmin() ? <RoastersPage /> : <NotFoundPage />;
}

function CrawlRunsRoute() {
  return useIsAdmin() ? <CrawlRunsPage /> : <NotFoundPage />;
}

function GreenCoffeeReviewRoute() {
  return useIsAdmin() ? <GreenCoffeeReviewPage /> : <NotFoundPage />;
}

function ListingsReviewRoute() {
  return useIsAdmin() ? <ListingsReviewPage /> : <NotFoundPage />;
}

function RequestsRoute() {
  return useIsAdmin() ? <RequestsPage /> : <NotFoundPage />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<AdminRoute />} />
      <Route path="/admin/beta-users" element={<BetaUsersRoute />} />
      <Route path="/admin/roasters" element={<RoastersRoute />} />
      <Route path="/admin/roasters/:roasterId/review" element={<ListingsReviewRoute />} />
      <Route path="/admin/crawl-runs" element={<CrawlRunsRoute />} />
      <Route path="/admin/green-coffee" element={<GreenCoffeeReviewRoute />} />
      <Route path="/admin/request" element={<RequestsRoute />} />
      <Route path="/request" element={<RequestPage />} />
      <Route path="/coffee/:id" element={<CoffeeDetailPage />} />
      <Route path="/coffee/:id/check-in" element={<CoffeeCheckInPage />} />
      <Route path="/me" element={<AccountPage />} />
      <Route path="/search" element={<SearchResultsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
